import { StringParam, useQueryParams } from 'use-query-params'

import { useQueryList } from '@percent/utility'
import { GrantsProgramsTable } from './grantsProgramsTable/GrantsProgramsTable'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'

const PROGRAMS_PAGE_SIZE = 25

export function GrantsProgramsContainer() {
  const { grantProgramService } = useServices()

  const [queryParams, setQueryParams] = useQueryParams({
    search: StringParam,
    partnerId: StringParam
  })

  const [{ totalResults, isLoading, data }, { refresh, nextPage, previousPage }] = useQueryList(
    ['/v1/admin/grants/programs', queryParams.search, queryParams.partnerId],
    grantProgramService.getAllPrograms,
    {
      ...queryParams,
      pageSize: PROGRAMS_PAGE_SIZE,
      search: queryParams.search ?? undefined,
      partnerId: queryParams.partnerId ?? undefined
    }
  )

  return (
    <GrantsProgramsTable
      data={data ?? []}
      totalResults={totalResults}
      isLoading={isLoading}
      nextPage={nextPage}
      previousPage={previousPage}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      onProgramAction={refresh}
    />
  )
}
